(function () {
  const inStockTemplate = document.getElementById('purestream-kaching-in-stock');
  const upsellShieldTemplate = document.getElementById('purestream-kaching-upsell-shield');
  const checkoutIconTemplate = document.getElementById('purestream-kaching-checkout-icon');
  const freeGiftsHeadingTemplate = document.getElementById('purestream-kaching-free-gifts-heading');
  const vetBannerTemplate = document.getElementById('purestream-kaching-vet-banner');
  const productShortNamesElement = document.getElementById('purestream-product-short-names');

  let PRODUCT_SHORT_NAMES = {};
  if (productShortNamesElement) {
    try {
      PRODUCT_SHORT_NAMES = JSON.parse(productShortNamesElement.textContent);
    } catch (error) {
      PRODUCT_SHORT_NAMES = {};
    }
  }

  function parseShortNamesPayload(payload) {
    if (!payload) return {};

    try {
      const jsonMatch = String(payload).match(/\{[\s\S]*\}/);
      return jsonMatch ? JSON.parse(jsonMatch[0]) : {};
    } catch (error) {
      return {};
    }
  }

  function mergeProductShortNames(nextMap) {
    PRODUCT_SHORT_NAMES = Object.assign({}, PRODUCT_SHORT_NAMES, nextMap);
  }

  async function refreshProductShortNamesFromCart(handles) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const params = new URLSearchParams();
    const uniqueHandles = Array.from(new Set((handles || []).filter(Boolean)));

    params.set('sections', 'el-product-short-names');

    if (uniqueHandles.length) {
      params.set('purestream_handles', uniqueHandles.join(','));
    }

    const response = await fetch(root + '?' + params.toString());

    if (!response.ok) return;

    const data = await response.json();
    mergeProductShortNames(parseShortNamesPayload(data['purestream-product-short-names']));
  }

  async function loadShortNamesForHandles(handles) {
    const uniqueHandles = Array.from(new Set((handles || []).filter(Boolean)));
    if (!uniqueHandles.length) return;

    const missingHandles = uniqueHandles.filter(function (handle) {
      return !PRODUCT_SHORT_NAMES[handle];
    });

    if (!missingHandles.length) return;

    await Promise.all(missingHandles.map(async function (handle) {
      try {
        const response = await fetch('/products/' + encodeURIComponent(handle) + '?view=short-name');
        if (!response.ok) return;

        const shortName = JSON.parse((await response.text()).trim());
        if (shortName) {
          PRODUCT_SHORT_NAMES[handle] = shortName;
        }
      } catch (error) {}
    }));
  }

  async function resolveProductShortNames(handles) {
    await refreshProductShortNamesFromCart(handles);
    await loadShortNamesForHandles(handles);
  }

  const UPSELL_COPY = {
    'splash-shield-mat': {
      title: 'Add Splash Shield Mat',
      subtitle: 'Catches every drop.\nNo more wet floors',
      recommended: false,
      useShield: false,
      layout: 'media',
      variantId: '40969730621504',
      inject: true,
      first: true,
      priceCents: 1995,
      image: 'https://cdn.shopify.com/s/files/1/0604/7127/9680/files/Untitleddesign_5.png?v=1776264107',
      url: '/products/splash-shield-mat'
    },
    'aquaone-lifetime-care': {
      title: 'Add Lifetime Care+',
      subtitle: 'Protect your pump for life',
      recommended: true,
      useShield: true,
      variantId: '40981855207488'
    },
    'aquaone-lifetime-care-dev': {
      title: 'Add Lifetime Care+',
      subtitle: 'Protect your pump for life',
      recommended: true,
      useShield: true,
      variantId: '41291208196160'
    },
    'hydrationproof-at-home-cat-hydration-test': {
      title: 'Add HydrationProof Test',
      subtitle: 'Check your cat\u2019s hydration at home',
      recommended: false,
      useShield: false
    }
  };

  const NO_DISCOUNT_VARIANT_IDS = new Set(['40981855207488', '41291208196160']);
  const LIFETIME_CARE_HANDLES = new Set(['aquaone-lifetime-care', 'aquaone-lifetime-care-dev']);
  const LIFETIME_CARE_VARIANT_IDS = new Set(['40981855207488', '41291208196160']);

  function getUpsellVariantId(item, handle) {
    const copy = UPSELL_COPY[handle] || {};

    if (copy.variantId) return String(copy.variantId);
    if (item.dataset.variantId) return String(item.dataset.variantId);

    const variantNode = item.querySelector('[data-variant-id]');
    if (variantNode && variantNode.dataset.variantId) {
      return String(variantNode.dataset.variantId);
    }

    const addBtn = item.querySelector('.kaching-product-upsell-item__add-to-cart');
    if (addBtn && addBtn.dataset.variantId) {
      return String(addBtn.dataset.variantId);
    }

    return null;
  }

  function isFreeGiftCartLine(item) {
    return !!(item && item.parent_relationship && item.parent_relationship.parent_key);
  }

  function getCartVariantIdSet(cartData, paidOnly) {
    const ids = new Set();

    (cartData && cartData.items ? cartData.items : []).forEach(function (item) {
      if (paidOnly && isFreeGiftCartLine(item)) return;
      if (item.variant_id != null) ids.add(String(item.variant_id));
      if (item.id != null) ids.add(String(item.id));
    });

    return ids;
  }

  function getCartHandleSet(cartData, paidOnly) {
    const handles = new Set();

    (cartData && cartData.items ? cartData.items : []).forEach(function (item) {
      if (paidOnly && isFreeGiftCartLine(item)) return;
      if (item.handle) handles.add(item.handle);
    });

    return handles;
  }

  function formatUpsellMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeUpsellAttr(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function buildInjectedUpsellSlide(handle, copy) {
    const variantId = String(copy.variantId || '');
    const url = escapeUpsellAttr(copy.url || ('/products/' + handle));
    const image = escapeUpsellAttr(copy.image || '');
    const title = escapeUpsellAttr(copy.title || handle);
    const priceText = escapeUpsellAttr(formatUpsellMoney(copy.priceCents || 0));

    // Match Kaching's native <li class="kaching-cart__carousel-item ..."> slide markup
    return (
      '<li class="kaching-cart__carousel-item kaching-product-upsell-item-container purestream-injected-upsell" data-purestream-injected-upsell="' + escapeUpsellAttr(handle) + '"' + (copy.first ? ' data-purestream-first="true"' : '') + '>' +
        '<div class="kaching-product-upsell-item" data-product-handle="' + escapeUpsellAttr(handle) + '" data-variant-id="' + escapeUpsellAttr(variantId) + '">' +
          '<div class="kaching-product-upsell-item__image-container">' +
            '<a href="' + url + '">' +
              (image
                ? '<img class="kaching-product-upsell-item__image" src="' + image + '" alt="' + title + '" loading="lazy">'
                : '') +
            '</a>' +
          '</div>' +
          '<div class="kaching-product-upsell-item__content">' +
            '<a class="kaching-product-upsell-item__title" href="' + url + '">' + title + '</a>' +
            '<div class="kaching-product-upsell-item__price-container">' +
              '<span class="kaching-product-upsell-item__price-final">' + priceText + '</span>' +
            '</div>' +
            '<div class="kaching-product-upsell-item__footer">' +
              '<button type="button" class="kaching-product-upsell-item__add-to-cart" data-variant-id="' + escapeUpsellAttr(variantId) + '">ADD</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  function buildUpsellCarouselHostMarkup() {
    return (
      '<div class="kaching-upsell-module--product-upsell purestream-upsell-host">' +
        '<div class="kaching-cart__carousel purestream-carousel-single">' +
          '<button type="button" class="kaching-cart__carousel-nav-button kaching-cart__carousel-prev" aria-label="Previous slide">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M12.8333 6.99999H1.16663M1.16663 6.99999L6.99996 12.8333M1.16663 6.99999L6.99996 1.16666" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
          '</button>' +
          '<ul class="kaching-cart__carousel-list" aria-label="Product recommendations"></ul>' +
          '<button type="button" class="kaching-cart__carousel-nav-button kaching-cart__carousel-next" aria-label="Next slide">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.16663 6.99999H12.8333M12.8333 6.99999L6.99996 1.16666M12.8333 6.99999L6.99996 12.8333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  let upsellHideGeneration = 0;
  let upsellReassertTimers = [];
  let upsellHideInFlight = false;
  let upsellHideQueued = false;
  let upsellReassertCount = 0;
  let cartOpenWaitingUntil = 0;
  let observerPaused = false;
  let customizeDebounceTimer = null;
  let lastHideUpsellsAt = 0;

  function clearUpsellReassertTimers() {
    upsellReassertTimers.forEach(function (timerId) {
      clearTimeout(timerId);
    });
    upsellReassertTimers = [];
  }

  function pauseObserver() {
    observerPaused = true;
    if (observer) observer.disconnect();
  }

  function resumeObserver() {
    observerPaused = false;
    if (observer) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function hasKachingSkeleton(drawer) {
    if (!drawer) return false;

    // Keep selectors specific — broad [class*="skeleton"] can false-positive forever
    return !!drawer.querySelector(
      [
        '.kaching-cart__skeleton',
        '.kaching-cart-skeleton',
        '.kaching-skeleton',
        '.kaching-cart-item-skeleton',
        '.kaching-cart-item--skeleton',
        '.kaching-cart__placeholder',
        '.kaching-placeholder',
        '[data-kaching-skeleton]'
      ].join(',')
    );
  }

  function hasKachingCartContent(drawer) {
    if (!drawer) return false;

    if (
      drawer.querySelector(
        '.kaching-cart__empty, .kaching-cart-empty, [data-kaching-empty], .kaching-cart__empty-cart'
      )
    ) {
      return true;
    }

    return !!drawer.querySelector(
      [
        '.kaching-cart-item .kaching-cart-item__title',
        '.kaching-cart-item .kaching-cart-item__content',
        '.kaching-cart-item .kaching-cart-item__content-left',
        '.kaching-cart-item-container .kaching-cart-item__title'
      ].join(',')
    );
  }

  function isKachingCartLoading(drawer) {
    if (!drawer) return true;

    if (
      drawer.getAttribute('aria-busy') === 'true'
      || drawer.classList.contains('is-loading')
      || drawer.classList.contains('kaching-cart--loading')
    ) {
      return true;
    }

    if (hasKachingSkeleton(drawer)) return true;

    // Short window after open only — never block forever if selectors miss
    if (Date.now() < cartOpenWaitingUntil && !hasKachingCartContent(drawer)) {
      return true;
    }

    return false;
  }

  function setUpsellWaitingState(drawer, waiting) {
    if (!drawer) return;

    const root = document.querySelector('#kaching-cart, .kaching-cart');
    const nextWaiting = !!waiting;
    const drawerWaiting = drawer.classList.contains('purestream-upsell-waiting');
    const rootWaiting = !!(root && root.classList.contains('purestream-upsell-waiting'));

    // Avoid class thrash that can cascade into more work
    if (drawerWaiting === nextWaiting && rootWaiting === nextWaiting) {
      if (nextWaiting) {
        drawer.querySelectorAll('.kaching-upsell-module--product-upsell.purestream-upsell-force-show').forEach(function (upsellModule) {
          upsellModule.classList.remove('purestream-upsell-force-show');
          upsellModule.hidden = true;
          upsellModule.setAttribute('aria-hidden', 'true');
        });
      }
      return;
    }

    drawer.classList.toggle('purestream-upsell-waiting', nextWaiting);
    if (root) root.classList.toggle('purestream-upsell-waiting', nextWaiting);

    if (nextWaiting) {
      drawer.querySelectorAll('.kaching-upsell-module--product-upsell').forEach(function (upsellModule) {
        upsellModule.classList.remove('purestream-upsell-force-show');
        upsellModule.hidden = true;
        upsellModule.setAttribute('aria-hidden', 'true');
      });
    }
  }

  function syncUpsellLoadingState(drawer) {
    if (!drawer) return true;

    const loading = isKachingCartLoading(drawer);
    setUpsellWaitingState(drawer, loading);
    return loading;
  }

  function revealUpsellModule(upsellModule, forceShow) {
    if (!upsellModule) return;

    const drawer = upsellModule.closest('kaching-cart-drawer')
      || document.querySelector('kaching-cart-drawer');

    // Never flash upsells over Kaching skeleton loaders
    if (drawer && isKachingCartLoading(drawer)) {
      upsellModule.classList.remove('purestream-upsell-force-show');
      upsellModule.hidden = true;
      upsellModule.setAttribute('aria-hidden', 'true');
      setUpsellWaitingState(drawer, true);
      return;
    }

    upsellModule.hidden = false;
    upsellModule.removeAttribute('hidden');
    upsellModule.style.removeProperty('display');
    upsellModule.style.removeProperty('visibility');
    upsellModule.style.removeProperty('height');
    upsellModule.style.removeProperty('overflow');
    upsellModule.removeAttribute('aria-hidden');

    if (forceShow) {
      upsellModule.classList.add('purestream-upsell-force-show');
    } else {
      upsellModule.classList.remove('purestream-upsell-force-show');
    }
  }

  function moduleHasVisibleUpsellSlides(upsellModule) {
    if (!upsellModule) return false;

    return Array.from(
      upsellModule.querySelectorAll('.kaching-cart__carousel-list > .kaching-cart__carousel-item')
    ).some(function (slide) {
      return !slide.classList.contains('purestream-upsell-in-cart');
    });
  }

  function ensureUpsellCarouselHost(drawer, options) {
    if (!drawer) return null;

    const opts = options || {};
    const allowCreate = opts.allowCreate !== false;
    let upsellModule = drawer.querySelector('.kaching-upsell-module--product-upsell');

    if (!upsellModule) {
      if (!allowCreate) return null;

      const hello = drawer.querySelector('.purestream-upsell-hello');
      const shipping = drawer.querySelector(
        '.kaching-upsell-module--shipping-protection, [data-kaching-shipping-protection], .kaching-cart__shipping-protection'
      );
      const modules = drawer.querySelectorAll('.kaching-cart__module');
      const lastModule = modules.length ? modules[modules.length - 1] : null;

      if (hello && hello.parentElement) {
        hello.insertAdjacentHTML('afterend', buildUpsellCarouselHostMarkup());
      } else if (shipping && shipping.parentElement) {
        shipping.insertAdjacentHTML('beforebegin', buildUpsellCarouselHostMarkup());
      } else if (lastModule && lastModule.parentElement) {
        lastModule.insertAdjacentHTML('beforebegin', buildUpsellCarouselHostMarkup());
      } else {
        const contents = drawer.querySelector('.kaching-cart__contents') || drawer;
        contents.insertAdjacentHTML('beforeend', buildUpsellCarouselHostMarkup());
      }

      upsellModule = drawer.querySelector('.kaching-upsell-module--product-upsell');
    }

    if (!upsellModule) return null;

    let carousel = upsellModule.querySelector('.kaching-cart__carousel');
    if (!carousel) {
      upsellModule.insertAdjacentHTML(
        'beforeend',
        '<div class="kaching-cart__carousel purestream-carousel-single">' +
          '<button type="button" class="kaching-cart__carousel-nav-button kaching-cart__carousel-prev" aria-label="Previous slide">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M12.8333 6.99999H1.16663M1.16663 6.99999L6.99996 12.8333M1.16663 6.99999L6.99996 1.16666" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
          '</button>' +
          '<ul class="kaching-cart__carousel-list" aria-label="Product recommendations"></ul>' +
          '<button type="button" class="kaching-cart__carousel-nav-button kaching-cart__carousel-next" aria-label="Next slide">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.16663 6.99999H12.8333M12.8333 6.99999L6.99996 1.16666M12.8333 6.99999L6.99996 12.8333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
          '</button>' +
        '</div>'
      );
      carousel = upsellModule.querySelector('.kaching-cart__carousel');
    }

    let list = upsellModule.querySelector('.kaching-cart__carousel-list');
    if (!list && carousel) {
      carousel.insertAdjacentHTML(
        'beforeend',
        '<ul class="kaching-cart__carousel-list" aria-label="Product recommendations"></ul>'
      );
      list = carousel.querySelector('.kaching-cart__carousel-list');
    }

    return list;
  }

  function getUpsellCarouselList(drawer, options) {
    return ensureUpsellCarouselHost(drawer, options);
  }

  async function fetchUpsellCartData() {
    if (window.kachingCartApi && typeof window.kachingCartApi.getCartData === 'function') {
      try {
        const cartData = await window.kachingCartApi.getCartData();
        if (cartData) return cartData;
      } catch (error) {}
    }

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return await fetch(root + 'cart.js').then(function (response) {
        return response.json();
      });
    } catch (error) {
      return null;
    }
  }

  function cartHasItems(cartData) {
    if (!cartData) return false;
    if (Number(cartData.item_count || 0) > 0) return true;
    return !!(cartData.items && cartData.items.length);
  }

  function shouldShowInjectedUpsell(handle, cartVariantIds, cartHandles, cartData) {
    const copy = UPSELL_COPY[handle] || {};
    if (!copy.inject || !copy.variantId) return false;

    // Never show Splash Mat (injected) upsells on an empty cart
    if (cartData && !cartHasItems(cartData)) return false;

    if (cartVariantIds && cartVariantIds.has(String(copy.variantId))) return false;
    if (handle && cartHandles && cartHandles.has(handle)) return false;

    return true;
  }

  function moveMisplacedInjectedUpsells(drawer) {
    const list = getUpsellCarouselList(drawer, { allowCreate: false });
    if (!list) return;

    drawer.querySelectorAll('.purestream-injected-upsell').forEach(function (slide) {
      if (slide.parentElement === list) return;
      if (slide.dataset.purestreamFirst === 'true' || slide.getAttribute('data-purestream-injected-upsell') === 'splash-shield-mat') {
        list.insertBefore(slide, list.firstElementChild);
        return;
      }
      list.appendChild(slide);
    });
  }

  function prioritizeFirstUpsellSlides(list) {
    if (!list) return;

    Object.keys(UPSELL_COPY).forEach(function (handle) {
      const copy = UPSELL_COPY[handle];
      if (!copy || !copy.first) return;

      let slide = list.querySelector('[data-purestream-injected-upsell="' + handle + '"]');
      if (!slide) {
        const productNode = list.querySelector('.kaching-product-upsell-item[data-product-handle="' + handle + '"]');
        slide = productNode && productNode.closest('.kaching-cart__carousel-item');
      }

      if (!slide || slide.parentElement !== list) return;
      if (list.firstElementChild !== slide) {
        list.insertBefore(slide, list.firstElementChild);
      }
    });
  }

  function syncPurestreamUpsellCarousel(carousel) {
    const list = carousel.querySelector('.kaching-cart__carousel-list');
    if (!list) return;

    const slides = Array.from(list.querySelectorAll(':scope > .kaching-cart__carousel-item')).filter(function (slide) {
      return !slide.classList.contains('purestream-upsell-in-cart');
    });

    const prev = carousel.querySelector('.kaching-cart__carousel-prev, .kaching-cart__carousel-nav-button.kaching-cart__carousel-prev');
    const next = carousel.querySelector('.kaching-cart__carousel-next, .kaching-cart__carousel-nav-button.kaching-cart__carousel-next');
    const multi = slides.length > 1;

    if (carousel.dataset.purestreamCarouselUserTouched !== 'true') {
      carousel.dataset.purestreamSlideIndex = '0';
    }

    let index = Number(carousel.dataset.purestreamSlideIndex || 0);
    if (index < 0) index = 0;
    if (index > slides.length - 1) index = Math.max(0, slides.length - 1);
    carousel.dataset.purestreamSlideIndex = String(index);

    // Hide arrows when only one visible slide — prevents overlap on Splash Mat card
    carousel.classList.toggle('purestream-carousel-single', !multi);
    carousel.classList.toggle('purestream-carousel-empty', slides.length === 0);

    slides.forEach(function (slide, i) {
      const active = i === index;
      slide.dataset.purestreamCarouselActive = active ? 'true' : 'false';
      slide.hidden = !active;
      slide.style.display = active ? '' : 'none';
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    [prev, next].forEach(function (btn) {
      if (!btn) return;
      if (!multi) {
        btn.style.display = 'none';
        btn.disabled = true;
        return;
      }

      btn.style.removeProperty('display');
      btn.disabled = false;
      btn.removeAttribute('disabled');
    });

    if (carousel.dataset.purestreamCarouselBound === 'true') return;
    carousel.dataset.purestreamCarouselBound = 'true';

    function go(delta) {
      const currentSlides = Array.from(list.querySelectorAll(':scope > .kaching-cart__carousel-item')).filter(function (slide) {
        return !slide.classList.contains('purestream-upsell-in-cart');
      });
      if (currentSlides.length <= 1) return;

      let nextIndex = Number(carousel.dataset.purestreamSlideIndex || 0) + delta;
      if (nextIndex < 0) nextIndex = currentSlides.length - 1;
      if (nextIndex >= currentSlides.length) nextIndex = 0;
      carousel.dataset.purestreamCarouselUserTouched = 'true';
      carousel.dataset.purestreamSlideIndex = String(nextIndex);
      syncPurestreamUpsellCarousel(carousel);
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(1);
      });
    }
  }

  function injectCustomUpsells(drawer, cartVariantIds, cartHandles, cartData) {
    if (!drawer) return;

    // Keep host/injection ready, but stay hidden while Kaching skeletons are on screen
    if (syncUpsellLoadingState(drawer)) {
      // Still prepare under the hood so the slide is ready the moment loading ends
    }

    const hasCartSets = !!(cartVariantIds && cartHandles);
    const drawerLooksEmpty = !!drawer.querySelector(
      '.kaching-cart__empty, .kaching-cart-empty, [data-kaching-empty], .kaching-cart__empty-cart'
    );

    // Without cart data, never create inject slides (avoids empty-cart flash)
    if (!hasCartSets) {
      if (drawerLooksEmpty) {
        drawer.querySelectorAll('[data-purestream-injected-upsell]').forEach(function (node) {
          node.remove();
        });
        updateUpsellCarouselVisibility(drawer);
      }
      return;
    }

    const shouldCreateHost = Object.keys(UPSELL_COPY).some(function (handle) {
      return shouldShowInjectedUpsell(handle, cartVariantIds, cartHandles, cartData);
    });

    // Never create an empty host when we already know inject upsells should be hidden
    const list = getUpsellCarouselList(drawer, { allowCreate: shouldCreateHost });
    if (!list) {
      drawer.querySelectorAll('[data-purestream-injected-upsell]').forEach(function (node) {
        node.remove();
      });
      return;
    }

    moveMisplacedInjectedUpsells(drawer);

    Object.keys(UPSELL_COPY).forEach(function (handle) {
      const copy = UPSELL_COPY[handle];
      if (!copy || !copy.inject || !copy.variantId) return;

      // Only keep inject slides that should still show (hides on empty cart / already in cart)
      if (!shouldShowInjectedUpsell(handle, cartVariantIds, cartHandles, cartData)) {
        drawer.querySelectorAll('[data-purestream-injected-upsell="' + handle + '"]').forEach(function (node) {
          node.remove();
        });
        return;
      }

      const nativeSlide = list.querySelector(
        '.kaching-product-upsell-item[data-product-handle="' + handle + '"]'
      );
      if (nativeSlide && !nativeSlide.closest('.purestream-injected-upsell')) return;

      const existingInjected = list.querySelector(
        '[data-purestream-injected-upsell="' + handle + '"]'
      );
      if (existingInjected) {
        if (copy.first) prioritizeFirstUpsellSlides(list);
        return;
      }

      drawer.querySelectorAll('[data-purestream-injected-upsell="' + handle + '"]').forEach(function (node) {
        if (node.parentElement !== list) node.remove();
      });

      if (copy.first) {
        list.insertAdjacentHTML('afterbegin', buildInjectedUpsellSlide(handle, copy));
      } else {
        list.insertAdjacentHTML('beforeend', buildInjectedUpsellSlide(handle, copy));
      }
    });

    prioritizeFirstUpsellSlides(list);

    const carousel = list.closest('.kaching-cart__carousel');
    if (carousel && carousel.dataset.purestreamCarouselUserTouched !== 'true') {
      carousel.dataset.purestreamSlideIndex = '0';
    }
  }

  function isLifetimeCareUpsell(handle, variantId) {
    return LIFETIME_CARE_HANDLES.has(handle) || (variantId && LIFETIME_CARE_VARIANT_IDS.has(String(variantId)));
  }

  function cartHasLifetimeCare(cartVariantIds, cartHandles) {
    for (const handle of LIFETIME_CARE_HANDLES) {
      if (cartHandles.has(handle)) return true;
    }

    for (const variantId of LIFETIME_CARE_VARIANT_IDS) {
      if (cartVariantIds.has(variantId)) return true;
    }

    return false;
  }

  function getUpsellContainer(item) {
    return item.closest('.kaching-cart__carousel-item')
      || item.closest('.kaching-product-upsell-item-container')
      || item;
  }

  function setUpsellVisibility(container, shouldShow) {
    if (!container) return;

    if (shouldShow) {
      container.hidden = false;
      container.style.removeProperty('display');
      container.removeAttribute('aria-hidden');
      container.classList.remove('purestream-upsell-in-cart');
      return;
    }

    container.hidden = true;
    container.style.display = 'none';
    container.setAttribute('aria-hidden', 'true');
    container.classList.add('purestream-upsell-in-cart');
  }

  function updateUpsellCarouselVisibility(drawer) {
    if (syncUpsellLoadingState(drawer)) return;

    drawer.querySelectorAll('.kaching-upsell-module--product-upsell').forEach(function (upsellModule) {
      const carousel = upsellModule.querySelector('.kaching-cart__carousel');
      if (carousel) syncPurestreamUpsellCarousel(carousel);

      if (moduleHasVisibleUpsellSlides(upsellModule)) {
        revealUpsellModule(upsellModule, true);
      } else {
        upsellModule.classList.remove('purestream-upsell-force-show');
        upsellModule.hidden = true;
      }
    });
  }

  function applyUpsellInCartVisibility(drawer, cartVariantIds, cartHandles, allCartVariantIds, allCartHandles) {
    let restoredFirstSlide = false;

    drawer.querySelectorAll('.kaching-product-upsell-item').forEach(function (item) {
      const handle = item.dataset.productHandle || '';
      const variantId = getUpsellVariantId(item, handle);
      const copy = UPSELL_COPY[handle] || {};
      const usePaidOnlyMatch = !!copy.inject;
      const variantSet = usePaidOnlyMatch ? cartVariantIds : allCartVariantIds;
      const handleSet = usePaidOnlyMatch ? cartHandles : allCartHandles;
      let inCart = (variantId && variantSet.has(variantId)) || (handle && handleSet.has(handle));

      // Addon uses aquaone-lifetime-care-dev; Kaching upsell may use aquaone-lifetime-care
      if (!inCart && isLifetimeCareUpsell(handle, variantId)) {
        inCart = cartHasLifetimeCare(allCartVariantIds, allCartHandles);
      }

      const container = getUpsellContainer(item);
      const wasHidden = !!(container && container.classList.contains('purestream-upsell-in-cart'));

      setUpsellVisibility(container, !inCart);

      if (!inCart && wasHidden && (copy.first || copy.inject)) {
        restoredFirstSlide = true;
      }
    });

    return restoredFirstSlide;
  }

  function scheduleUpsellReassert(generation) {
    clearUpsellReassertTimers();

    // One delayed pass only — multiple timers were stacking with the MutationObserver
    const timerId = setTimeout(function () {
      if (generation !== upsellHideGeneration) return;
      requestHideUpsellsAlreadyInCart(true);
    }, 450);

    upsellReassertTimers.push(timerId);
  }

  function requestHideUpsellsAlreadyInCart(force) {
    const now = Date.now();
    if (!force && now - lastHideUpsellsAt < 250) {
      upsellHideQueued = true;
      return;
    }

    if (upsellHideInFlight) {
      upsellHideQueued = true;
      return;
    }

    hideUpsellsAlreadyInCart();
  }

  async function hideUpsellsAlreadyInCart() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return;

    if (upsellHideInFlight) {
      upsellHideQueued = true;
      return;
    }

    upsellHideInFlight = true;
    upsellHideQueued = false;
    lastHideUpsellsAt = Date.now();

    const generation = ++upsellHideGeneration;
    clearUpsellReassertTimers();
    pauseObserver();

    try {
      const cartData = await fetchUpsellCartData();
      if (generation !== upsellHideGeneration || !cartData) return;

      // Ignore free-gift lines so gift products can still appear as paid upsells
      const cartVariantIds = getCartVariantIdSet(cartData, true);
      const cartHandles = getCartHandleSet(cartData, true);
      const allCartVariantIds = getCartVariantIdSet(cartData, false);
      const allCartHandles = getCartHandleSet(cartData, false);

      // Keep Splash Mat mounted even when Kaching tears down native Lifetime Care upsells
      const hasVisibleInjectUpsell = Object.keys(UPSELL_COPY).some(function (handle) {
        return shouldShowInjectedUpsell(handle, cartVariantIds, cartHandles, cartData);
      });

      injectCustomUpsells(drawer, cartVariantIds, cartHandles, cartData);
      // Style after inject — injected Splash Mat was previously left in native Kaching markup
      styleUpsellItems(drawer);

      const restoredFirstSlide = applyUpsellInCartVisibility(
        drawer,
        cartVariantIds,
        cartHandles,
        allCartVariantIds,
        allCartHandles
      );

      if (hasVisibleInjectUpsell) {
        const list = getUpsellCarouselList(drawer, { allowCreate: true });
        prioritizeFirstUpsellSlides(list);
      }

      if (restoredFirstSlide || hasVisibleInjectUpsell) {
        const list = getUpsellCarouselList(drawer, { allowCreate: hasVisibleInjectUpsell });
        prioritizeFirstUpsellSlides(list);
        drawer.querySelectorAll('.kaching-cart__carousel').forEach(function (carousel) {
          delete carousel.dataset.purestreamCarouselUserTouched;
          carousel.dataset.purestreamSlideIndex = '0';
        });
      }

      // Stay hidden until Kaching finishes skeleton loading, then reveal
      if (!syncUpsellLoadingState(drawer)) {
        updateUpsellCarouselVisibility(drawer);
      }

      // One or two follow-ups max while skeletons remain — never loop forever
      if (
        hasVisibleInjectUpsell
        && isKachingCartLoading(drawer)
        && upsellReassertCount < 2
      ) {
        upsellReassertCount += 1;
        scheduleUpsellReassert(generation);
      } else if (!isKachingCartLoading(drawer)) {
        upsellReassertCount = 0;
      }
    } finally {
      upsellHideInFlight = false;
      if (!customizingKachingCart) resumeObserver();
      if (upsellHideQueued) {
        upsellHideQueued = false;
        setTimeout(function () {
          requestHideUpsellsAlreadyInCart(true);
        }, 100);
      }
    }
  }

  function isNoDiscountUpsell(item, handle) {
    return NO_DISCOUNT_VARIANT_IDS.has(getUpsellVariantId(item, handle));
  }

  function updateUpsellButton(item) {
    const addBtn = item.querySelector('.kaching-product-upsell-item__add-to-cart');
    const handle = item.dataset.productHandle || '';
    const priceEl = isNoDiscountUpsell(item, handle)
      ? (item.querySelector('.kaching-product-upsell-item__price-old')
        || item.querySelector('.kaching-product-upsell-item__price-final'))
      : item.querySelector('.kaching-product-upsell-item__price-final');
    if (!addBtn || !priceEl) return;

    const priceText = priceEl.textContent.trim();
    if (!priceText || addBtn.dataset.purestreamPrice === priceText) return;

    addBtn.textContent = 'ADD +' + priceText;
    addBtn.dataset.purestreamPrice = priceText;
  }

  function shouldInterceptUpsellAdd(item, handle) {
    const copy = UPSELL_COPY[handle] || {};
    return !!copy.inject || isNoDiscountUpsell(item, handle);
  }

  async function addUpsellViaCartApi(item, handle) {
    const variantId = getUpsellVariantId(item, handle);
    if (!variantId) return false;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    if (!response.ok) return false;

    pauseObserver();

    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.refresh === 'function') {
        await window.kachingCartApi.refresh();
      }
    } catch (error) {
    } finally {
      if (!customizingKachingCart) resumeObserver();
    }

    setTimeout(function () {
      requestHideUpsellsAlreadyInCart(true);
    }, 50);
    return true;
  }

  function resolveUpsellCopy(item) {
    const handle = item.dataset.productHandle || '';
    if (handle && UPSELL_COPY[handle]) return { handle: handle, copy: UPSELL_COPY[handle] };

    const variantId = getUpsellVariantId(item, handle);
    if (!variantId) return { handle: handle, copy: {} };

    const matchedHandle = Object.keys(UPSELL_COPY).find(function (key) {
      return String(UPSELL_COPY[key].variantId || '') === String(variantId);
    });

    if (!matchedHandle) return { handle: handle, copy: {} };
    if (!handle) item.dataset.productHandle = matchedHandle;
    return { handle: matchedHandle, copy: UPSELL_COPY[matchedHandle] };
  }

  function styleUpsellItems(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('.kaching-product-upsell-item').forEach(function (item) {
      const resolved = resolveUpsellCopy(item);
      const handle = resolved.handle;
      const copy = resolved.copy || {};
      const titleLink = item.querySelector('.kaching-product-upsell-item__title');
      const content = item.querySelector('.kaching-product-upsell-item__content');
      const footer = item.querySelector('.kaching-product-upsell-item__footer');
      const productImage = item.querySelector('.kaching-product-upsell-item__image');
      const mediaLayout = copy.layout === 'media';

      if (!titleLink || !content || !footer) return;

      item.classList.add('purestream-upsell-item');
      item.classList.toggle('purestream-upsell-item--media', mediaLayout);

      if (item.dataset.purestreamUpsellStyled === 'true') {
        updateUpsellButton(item);
        return;
      }

      const rawTitle = titleLink.textContent.trim();
      const displayTitle = copy.title || (rawTitle.match(/^Add\s+/i) ? rawTitle : 'Add ' + rawTitle);

      titleLink.innerHTML = '';
      const titleText = document.createElement('span');
      titleText.className = 'purestream-upsell-title-text';
      titleText.textContent = displayTitle;
      titleLink.appendChild(titleText);

      const info = document.createElement('div');
      info.className = 'purestream-upsell-info';

      const titleRow = document.createElement('div');
      titleRow.className = 'purestream-upsell-title-row';

      // Media layout keeps the left product thumbnail; other upsells use compact icon-in-title
      if (!mediaLayout) {
        if (copy.useShield && upsellShieldTemplate) {
          titleRow.insertAdjacentHTML('beforeend', upsellShieldTemplate.innerHTML);
        } else if (productImage) {
          const iconWrap = document.createElement('span');
          iconWrap.className = 'purestream-upsell-icon';
          const iconImg = productImage.cloneNode(true);
          iconImg.removeAttribute('loading');
          iconWrap.appendChild(iconImg);
          titleRow.appendChild(iconWrap);
        }
      }

      titleRow.appendChild(titleLink);
      info.appendChild(titleRow);

      if (copy.subtitle) {
        const subtitle = document.createElement('p');
        subtitle.className = 'purestream-upsell-subtitle';
        subtitle.textContent = copy.subtitle;
        if (copy.subtitle.indexOf('\n') !== -1) {
          subtitle.classList.add('purestream-upsell-subtitle--multiline');
        }
        info.appendChild(subtitle);
      }

      const actions = document.createElement('div');
      actions.className = 'purestream-upsell-actions';

      if (copy.recommended) {
        const badge = document.createElement('span');
        badge.className = 'purestream-upsell-recommended';
        badge.textContent = 'RECOMMENDED';
        actions.appendChild(badge);
      } else if (!mediaLayout) {
        actions.appendChild(document.createElement('span'));
      }

      actions.appendChild(footer);
      content.insertBefore(info, content.firstChild);
      content.appendChild(actions);

      item.dataset.purestreamUpsellStyled = 'true';
      updateUpsellButton(item);
    });
  }

  function customizeUpsellCarousel() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return;

    // Hide first while Kaching is skeleton-loading; reveal after items hydrate
    syncUpsellLoadingState(drawer);
    injectCustomUpsells(drawer);
    styleUpsellItems(drawer);
    requestHideUpsellsAlreadyInCart(false);
  }

  function injectFreeGiftsHeading() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer || !freeGiftsHeadingTemplate) return;

    drawer.querySelectorAll('.kaching-cart-item-container').forEach(function (container) {
      const extraItems = container.querySelector('.kaching-cart-extra-items-container');
      if (!extraItems) return;

       if (!container.querySelector('.purestream-vet-recommended-banner') && vetBannerTemplate) {
        const heading = container.querySelector('.purestream-free-gifts-heading');
        if (heading) {
          heading.insertAdjacentHTML('beforebegin', vetBannerTemplate.innerHTML);
        } else {
          extraItems.insertAdjacentHTML('beforebegin', vetBannerTemplate.innerHTML);
        }
      } 

      /* if (!container.querySelector('.purestream-free-gifts-heading')) { extraItems.insertAdjacentHTML('beforebegin', freeGiftsHeadingTemplate.innerHTML); } */
    });
  }

  function escapeHtml(value) {
    const node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function formatGiftPrice(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }

    return (Number(cents || 0) / 100).toFixed(2);
  }

  const FOUNTAIN_HANDLE = 'purestream-aquaone';
  const FOUNTAIN_VARIANT_ID = '40969640312896';
  const GIFT_CATALOG = [
    { variantId: 40969730621504, handle: 'splash-shield-mat' },
    { variantId: 40969730850880, handle: 'procare-kit' },
    { variantId: 40969734389824, handle: 'surprise-box' },
    { variantId: 40969777545280, handle: 'the-hydrated-cat-method' }
  ];
  const GIFT_VARIANT_IDS = new Set(GIFT_CATALOG.map(function (g) { return String(g.variantId); }));
  const CHECKOUT_RETURN_KEY = 'purestream_checkout_started';
  let checkoutDedupInFlight = false;
  let checkoutReturnClearInFlight = false;

  function parseKachingBundleMeta(item) {
    const prop = item && item.properties && item.properties.__kaching_bundles;
    if (!prop) return null;

    try {
      return typeof prop === 'string' ? JSON.parse(prop) : prop;
    } catch (error) {
      return null;
    }
  }

  function isCatalogGift(item) {
    return GIFT_VARIANT_IDS.has(String(item && (item.variant_id || item.id)));
  }

  function isKachingBundleGift(item) {
    if (isCatalogGift(item)) return true;
    const meta = parseKachingBundleMeta(item);
    return !!(meta && meta.gift);
  }

  function isEligibleFountain(item) {
    if (!item) return false;
    if (item.handle === FOUNTAIN_HANDLE) return true;
    if (String(item.variant_id || item.id) === FOUNTAIN_VARIANT_ID) return true;
    const meta = parseKachingBundleMeta(item);
    return !!(meta && meta.main);
  }

  function getEligibleFountains(cartData) {
    return (cartData && cartData.items ? cartData.items : []).filter(isEligibleFountain);
  }

  function getAnchorFountain(cartData) {
    const fountains = getEligibleFountains(cartData);
    return fountains.length ? fountains[fountains.length - 1] : null;
  }

  function getDuplicateGiftUpdates(cartData) {
    const anchor = getAnchorFountain(cartData);
    if (!anchor) return {};

    const anchorKey = anchor.key;
    const updates = {};
    const keptVariants = new Set();

    (cartData.items || []).forEach(function (item) {
      if (!isKachingBundleGift(item)) return;

      const parentKey = item.parent_relationship && item.parent_relationship.parent_key;
      const variantId = String(item.variant_id || item.id);

      if (parentKey === anchorKey) {
        if (keptVariants.has(variantId)) updates[item.key] = 0;
        else keptVariants.add(variantId);
        return;
      }

      if (parentKey && parentKey !== anchorKey) updates[item.key] = 0;
    });

    (cartData.items || []).forEach(function (item) {
      if (!isKachingBundleGift(item)) return;

      const parentKey = item.parent_relationship && item.parent_relationship.parent_key;
      if (parentKey) return;

      const variantId = String(item.variant_id || item.id);
      if (keptVariants.has(variantId)) updates[item.key] = 0;
      else keptVariants.add(variantId);
    });

    return updates;
  }

  function getAdjustedItemCount(cartData) {
    if (!cartData || !cartData.items) return null;

    const duplicateUpdates = getDuplicateGiftUpdates(cartData);
    const duplicateKeys = new Set(Object.keys(duplicateUpdates));
    let count = 0;

    cartData.items.forEach(function (item) {
      if (duplicateKeys.has(item.key)) return;
      count += Number(item.quantity || 1);
    });

    return count;
  }

  function queryKachingDrawerNodes(selector) {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return [];

    const nodes = Array.from(drawer.querySelectorAll(selector));
    if (drawer.shadowRoot) {
      Array.prototype.push.apply(nodes, Array.from(drawer.shadowRoot.querySelectorAll(selector)));
    }

    return nodes;
  }

  function applyAdjustedCountToHeading(heading, adjustedCount) {
    if (!heading || adjustedCount == null) return;

    if (!heading.dataset.purestreamHeadingBase) {
      heading.dataset.purestreamHeadingBase = heading.textContent.trim();
    }

    const base = heading.dataset.purestreamHeadingBase;
    const expected = /\d+/.test(base)
      ? base.replace(/\d+/, String(adjustedCount))
      : base + ' (' + adjustedCount + ')';

    if (heading.textContent.trim() !== expected) {
      heading.textContent = expected;
    }

    heading.dataset.purestreamAdjustedCount = String(adjustedCount);
  }

  async function updateCartHeadingCount() {
    const cartData = await fetchCartData();
    if (!cartData) return;

    const adjustedCount = getAdjustedItemCount(cartData);
    if (adjustedCount == null) return;

    queryKachingDrawerNodes('.kaching-cart__heading').forEach(function (heading) {
      applyAdjustedCountToHeading(heading, adjustedCount);
    });
  }

  async function fetchCartData() {
    if (!window.kachingCartApi || typeof window.kachingCartApi.getCartData !== 'function') {
      return null;
    }

    try {
      return await window.kachingCartApi.getCartData();
    } catch (error) {
      return null;
    }
  }

  async function dedupeGiftsBeforeCheckout() {
    if (checkoutDedupInFlight) return;
    checkoutDedupInFlight = true;

    try {
      const cartData = await fetchCartData();
      if (!cartData || !cartData.items || !cartData.items.length) return;

      const noFreeGiftUpdates = getParentRelationshipRemovalUpdates(cartData);
      const duplicateUpdates = cartHasNoFreeGiftProperty(cartData)
        ? {}
        : getDuplicateGiftUpdates(cartData);
      const updates = Object.assign({}, duplicateUpdates, noFreeGiftUpdates);
      const lineKeys = Object.keys(updates);
      if (!lineKeys.length) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } finally {
      checkoutDedupInFlight = false;
    }
  }

  function markCheckoutStarted() {
    try {
      localStorage.setItem(CHECKOUT_RETURN_KEY, JSON.stringify({
        startedAt: Date.now(),
        from: window.location.pathname
      }));
      history.pushState({ purestreamCheckoutStarted: true }, '', window.location.href);
    } catch (error) {}
  }

  function hasCheckoutStarted() {
    try {
      return !!localStorage.getItem(CHECKOUT_RETURN_KEY);
    } catch (error) {
      return false;
    }
  }

  async function refreshHeaderCartCount() {
    if (typeof window.refreshHeaderCartCount === 'function') {
      await window.refreshHeaderCartCount();
      return;
    }

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cart = await fetch(root + 'cart.js').then(function (response) {
        return response.json();
      });
      const count = Number(cart.item_count || 0);
      const cartIcon = document.querySelector('#cart-icon-bubble, .el-site-header__cart');

      document.querySelectorAll('.el-site-header__cart-count').forEach(function (el) {
        el.remove();
      });

      if (count > 0 && cartIcon) {
        const badge = document.createElement('span');
        badge.className = 'el-site-header__cart-count';
        badge.textContent = String(count);
        cartIcon.appendChild(badge);
      }
    } catch (error) {}
  }

  async function clearCartAfterCheckoutReturn() {
    if (checkoutReturnClearInFlight) return;
    if (!hasCheckoutStarted()) return;

    checkoutReturnClearInFlight = true;

    try {
      localStorage.removeItem(CHECKOUT_RETURN_KEY);

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      await fetch(root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      if (window.kachingCartApi && typeof window.kachingCartApi.refresh === 'function') {
        try {
          await window.kachingCartApi.refresh();
        } catch (error) {}
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      await refreshHeaderCartCount();
      customizeKachingCart();
    } catch (error) {
    } finally {
      checkoutReturnClearInFlight = false;
    }
  }

  function handleCheckoutReturn() {
    clearCartAfterCheckoutReturn();
  }

  function cartHasNoFreeGiftProperty(cartData) {
    return (cartData && cartData.items ? cartData.items : []).some(function (item) {
      const value = item.properties && item.properties['no-free-gift'];
      return value === true || value === 'true';
    });
  }

  function getParentRelationshipRemovalUpdates(cartData) {
    if (!cartHasNoFreeGiftProperty(cartData)) return {};

    const updates = {};

    (cartData && cartData.items ? cartData.items : []).forEach(function (item) {
      if (!item.parent_relationship || !item.parent_relationship.parent_key) return;
      if (!item.key) return;
      updates[item.key] = 0;
    });

    return updates;
  }

  let removeParentGiftsInFlight = false;

  async function removeParentGiftsForNoFreeGift(cartData) {
    if (removeParentGiftsInFlight) return false;

    const sourceCart = cartData || await fetchCartData();
    if (!sourceCart) return false;

    const updates = getParentRelationshipRemovalUpdates(sourceCart);
    const lineKeys = Object.keys(updates);
    if (!lineKeys.length) return false;

    removeParentGiftsInFlight = true;

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (window.kachingCartApi && typeof window.kachingCartApi.refresh === 'function') {
        try {
          await window.kachingCartApi.refresh();
        } catch (error) {}
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      return true;
    } catch (error) {
      return false;
    } finally {
      removeParentGiftsInFlight = false;
    }
  }

  function clearUpsellHelloContainers(drawer) {
    (drawer || document).querySelectorAll('.purestream-upsell-hello').forEach(function (container) {
      container.hidden = true;
      container.innerHTML = '';
      delete container.dataset.purestreamGiftSignature;
    });
  }

  function ensureUpsellHelloContainer(upsellModule) {
    const parent = upsellModule.parentElement;
    if (!parent) return null;

    let container = parent.querySelector('.purestream-upsell-hello');
    if (!container) {
      upsellModule.insertAdjacentHTML('beforebegin', '<div class="purestream-upsell-hello" hidden></div>');
      container = parent.querySelector('.purestream-upsell-hello');
    }

    return container;
  }

  function getGiftItemUniqueKey(item) {
    if (item.product_id != null) return 'product:' + item.product_id;
    if (item.id != null) return 'variant:' + item.id;
    if (item.handle) return 'handle:' + item.handle;

    const title = String(item.product_title || item.title || '').trim().toLowerCase();
    if (title) return 'title:' + title;

    return 'key:' + item.key;
  }

  function getParentKeyGiftItems(cartData) {
    const seen = new Set();
    const uniqueItems = [];

    (cartData && cartData.items ? cartData.items : []).forEach(function (item) {
      if (!item.parent_relationship || !item.parent_relationship.parent_key) return;

      const uniqueKey = getGiftItemUniqueKey(item);
      if (seen.has(uniqueKey)) return;

      seen.add(uniqueKey);
      uniqueItems.push(item);
    });

    return uniqueItems;
  }

  function getGiftDisplayTitle(item, shortNamesMap) {
    const namesMap = shortNamesMap || PRODUCT_SHORT_NAMES;
    const handle = item.handle;

    if (handle && namesMap[handle]) {
      return namesMap[handle];
    }

    return item.product_title || item.title || '';
  }

  function buildParentKeyGiftMarkup(giftItems, shortNamesMap) {
    const itemsHtml = giftItems.map(function (item) {
      const title = escapeHtml(getGiftDisplayTitle(item, shortNamesMap));
      const imageUrl = item.image ? escapeHtml(item.image) : '';
      const imageAlt = escapeHtml(getGiftDisplayTitle(item, shortNamesMap));
      const comparePrice = item.compare_at_price || item.original_price || item.price || 0;

      return (
        '<div class="purestream-upsell-hello__item">' +
          '<div class="purestream-upsell-hello__image">' +
            (imageUrl ? '<img src="' + imageUrl + '" alt="' + imageAlt + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="purestream-upsell-hello__info">' +
            '<p class="purestream-upsell-hello__title">' + title + '</p>' +
            '<div class="purestream-upsell-hello__price">' +
              '<span class="purestream-upsell-hello__free">FREE</span>' +
              '<s class="purestream-upsell-hello__compare">' + formatGiftPrice(comparePrice) + '</s>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    return (
      '<p class="purestream-free-gifts-heading"><strong>FREE gifts Included:</strong></p>' +
      '<div class="purestream-upsell-hello__grid">' + itemsHtml + '</div>'
    );
  }

  async function renderParentKeyGifts() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return;

    const upsellModules = drawer.querySelectorAll('.kaching-upsell-module--product-upsell');
    if (!upsellModules.length) return;

    if (!window.kachingCartApi || typeof window.kachingCartApi.getCartData !== 'function') {
      clearUpsellHelloContainers(drawer);
      return;
    }

    let cartData;
    try {
      cartData = await window.kachingCartApi.getCartData();
    } catch (error) {
      return;
    }

    if (cartHasNoFreeGiftProperty(cartData)) {
      clearUpsellHelloContainers(drawer);
      await removeParentGiftsForNoFreeGift(cartData);
      return;
    }

    const giftItems = getParentKeyGiftItems(cartData);
    const giftHandles = giftItems.map(function (item) {
      return item.handle;
    });

    await resolveProductShortNames(giftHandles);

    const giftMarkup = giftItems.length ? buildParentKeyGiftMarkup(giftItems, PRODUCT_SHORT_NAMES) : '';

    upsellModules.forEach(function (upsellModule) {
      if (!giftItems.length) {
        const existing = upsellModule.parentElement
          && upsellModule.parentElement.querySelector('.purestream-upsell-hello');
        if (existing) {
          existing.hidden = true;
          existing.innerHTML = '';
          delete existing.dataset.purestreamGiftSignature;
        }
        return;
      }

      const container = ensureUpsellHelloContainer(upsellModule);
      if (!container) return;

      const nextSignature = giftItems.map(getGiftItemUniqueKey).join('|');

      if (container.dataset.purestreamGiftSignature === nextSignature) {
        container.hidden = false;
        return;
      }

      container.dataset.purestreamGiftSignature = nextSignature;
      container.hidden = false;
      container.innerHTML = giftMarkup;
    });
  }

  function injectCheckoutIcon() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer || !checkoutIconTemplate) return;

    drawer.querySelectorAll('.kaching-cart__checkout-button').forEach(function (btn) {
      const textWrap = btn.querySelector('.kaching-cart__checkout-button-text');
      if (!textWrap || btn.querySelector('.purestream-kaching-checkout-icon')) return;
      textWrap.insertAdjacentHTML('beforebegin', checkoutIconTemplate.innerHTML);
    });
  }

  function injectInStockBadge() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer || !inStockTemplate) return;

    drawer.querySelectorAll('.kaching-cart-item__price-info > .kaching-cart__badge').forEach(function (badge) {
      if (badge.querySelector('.purestream-kaching-in-stock')) return;
      badge.insertAdjacentHTML('beforeend', inStockTemplate.innerHTML);
    });
  }

  function movePriceAboveQuantity() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('.kaching-cart-item__content-left').forEach(function (contentLeft) {
      const cartItem = contentLeft.closest('.kaching-cart-item');
      const quantityControls = contentLeft.querySelector('.kaching-cart-item__quantity-controls');
      const priceInfo = cartItem && cartItem.querySelector('.kaching-cart-item__price-info');

      if (!cartItem || !quantityControls || !priceInfo) return;

      if (priceInfo.parentElement === contentLeft && priceInfo.nextElementSibling === quantityControls) {
        return;
      }

      quantityControls.insertAdjacentElement('beforebegin', priceInfo);
      cartItem.classList.add('purestream-price-above-qty');
    });
  }

  function updateKachingSaveText() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('.kaching-cart__badge span, .kaching-product-upsell-item__badge').forEach(function (el) {
      if (el.closest('.purestream-kaching-in-stock')) return;
      if (!el.textContent.includes('You save')) return;

      const label = el.querySelector('.purestream-kaching-save-label');
      if (label) {
        const labelText = Array.from(label.childNodes)
          .filter(function (node) {
            return node.nodeType === Node.TEXT_NODE;
          })
          .map(function (node) {
            return node.textContent;
          })
          .join('');
        if (labelText.includes('You save') || label.textContent.includes('You save')) {
          Array.from(label.childNodes).forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) {
              node.textContent = node.textContent.replace(/You save/gi, 'Save');
            }
          });
        }
        return;
      }

      const svg = el.querySelector('svg');
      el.textContent = el.textContent.replace(/You save/g, 'Save');
      if (svg) el.prepend(svg);
    });
  }

  function formatSaveBadge() {
    const drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('.kaching-cart__badge').forEach(function (badge) {
      const saveSpan = Array.from(badge.querySelectorAll(':scope > span')).find(function (span) {
        return !span.classList.contains('purestream-kaching-in-stock');
      });
      if (!saveSpan) return;

      let svg = saveSpan.querySelector('svg');
      if (!svg) {
        const iconWrap = Array.from(badge.querySelectorAll(':scope > div')).find(function (div) {
          return (
            div.querySelector('svg') &&
            !div.classList.contains('purestream-kaching-save-text') &&
            !div.classList.contains('purestream-kaching-save-label') &&
            !div.classList.contains('purestream-kaching-save-amount')
          );
        });
        if (iconWrap) {
          svg = iconWrap.querySelector('svg');
          iconWrap.remove();
        }
      }

      const existingLabel = saveSpan.querySelector('.purestream-kaching-save-label');
      if (existingLabel) {
        if (svg && !existingLabel.contains(svg)) {
          existingLabel.prepend(svg);
        }
        return;
      }

      const rawText = Array.from(saveSpan.childNodes)
        .filter(function (node) {
          return node.nodeType === Node.TEXT_NODE;
        })
        .map(function (node) {
          return node.textContent;
        })
        .join('')
        .trim();

      const match = rawText.match(/^(?:You\s+)?Save\s+(.+)$/i);
      if (!match) return;

      Array.from(saveSpan.childNodes).forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SVG') node.remove();
      });

      const textWrap = document.createElement('div');
      textWrap.className = 'purestream-kaching-save-text';

      const label = document.createElement('div');
      label.className = 'purestream-kaching-save-label';
      label.appendChild(document.createTextNode('Save'));

      const amount = document.createElement('div');
      amount.className = 'purestream-kaching-save-amount';
      amount.textContent = match[1].trim();

      if (svg) label.prepend(svg);

      textWrap.appendChild(label);
      textWrap.appendChild(amount);
      saveSpan.appendChild(textWrap);
    });
  }

  let observer = null;
  let customizingKachingCart = false;

  function mutationTouchesKaching(mutations) {
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      const nodes = [];

      if (mutation.target) nodes.push(mutation.target);
      if (mutation.addedNodes && mutation.addedNodes.length) {
        Array.prototype.push.apply(nodes, mutation.addedNodes);
      }
      if (mutation.removedNodes && mutation.removedNodes.length) {
        Array.prototype.push.apply(nodes, mutation.removedNodes);
      }

      for (let j = 0; j < nodes.length; j++) {
        const node = nodes[j];
        if (!node || node.nodeType !== 1) continue;

        if (
          node.matches
          && node.matches('kaching-cart-drawer, #kaching-cart, .kaching-cart, .kaching-cart-item, .kaching-upsell-module--product-upsell, .kaching-cart__carousel, .kaching-product-upsell-item')
        ) {
          return true;
        }

        if (
          node.closest
          && node.closest('kaching-cart-drawer, #kaching-cart, .kaching-cart')
        ) {
          // Ignore our own injected/styled markers churning
          if (
            node.classList
            && (
              node.classList.contains('purestream-injected-upsell')
              || node.classList.contains('purestream-upsell-item')
              || node.classList.contains('purestream-upsell-info')
              || node.classList.contains('purestream-upsell-actions')
              || node.classList.contains('purestream-upsell-waiting')
              || node.classList.contains('purestream-upsell-force-show')
              || node.classList.contains('purestream-upsell-host')
            )
          ) {
            continue;
          }
          return true;
        }
      }
    }

    return false;
  }

  function scheduleCustomizeKachingCart() {
    if (customizingKachingCart || observerPaused || upsellHideInFlight) return;

    if (customizeDebounceTimer) clearTimeout(customizeDebounceTimer);
    customizeDebounceTimer = setTimeout(function () {
      customizeDebounceTimer = null;
      customizeKachingCart();
    }, 200);
  }

  function customizeKachingCart() {
    if (customizingKachingCart || observerPaused) return;

    customizingKachingCart = true;
    pauseObserver();

    try {
      const drawer = document.querySelector('kaching-cart-drawer');
      if (drawer) syncUpsellLoadingState(drawer);

      movePriceAboveQuantity();
      injectInStockBadge();
      updateKachingSaveText();
      formatSaveBadge();
      customizeUpsellCarousel();
      injectFreeGiftsHeading();
      renderParentKeyGifts();
      updateCartHeadingCount();
      injectCheckoutIcon();
    } finally {
      customizingKachingCart = false;
      if (!upsellHideInFlight) resumeObserver();
    }
  }

  observer = new MutationObserver(function (mutations) {
    if (customizingKachingCart || observerPaused || upsellHideInFlight) return;
    if (!mutationTouchesKaching(mutations)) return;
    scheduleCustomizeKachingCart();
  });
  resumeObserver();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kaching-cart], .cart-icon, .header__icon--cart')) {
      // Hide upsell briefly on open so it never flashes over skeletons
      cartOpenWaitingUntil = Date.now() + 1200;
      upsellReassertCount = 0;
      const drawer = document.querySelector('kaching-cart-drawer');
      const root = document.querySelector('#kaching-cart, .kaching-cart');
      if (drawer) setUpsellWaitingState(drawer, true);
      else if (root) root.classList.add('purestream-upsell-waiting');
      setTimeout(scheduleCustomizeKachingCart, 300);
    }

    if (e.target.closest('.kaching-product-upsell-item__add-to-cart')) {
      setTimeout(function () {
        requestHideUpsellsAlreadyInCart(true);
      }, 400);
    }
  });

  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.kaching-product-upsell-item__add-to-cart');
    if (!addBtn) return;

    const item = addBtn.closest('.kaching-product-upsell-item');
    if (!item) return;

    const handle = item.dataset.productHandle || '';
    if (!shouldInterceptUpsellAdd(item, handle)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (addBtn.dataset.purestreamAdding === 'true') return;
    addBtn.dataset.purestreamAdding = 'true';

    addUpsellViaCartApi(item, handle).finally(function () {
      delete addBtn.dataset.purestreamAdding;
    });
  }, true);

  document.addEventListener('cart:updated', function () {
    // Re-run full upsell customize so injected slides return after remove/refresh
    scheduleCustomizeKachingCart();
    removeParentGiftsForNoFreeGift();
  });

  document.addEventListener('click', function (e) {
    const checkoutBtn = e.target.closest('.kaching-cart__checkout-button, #kaching-cart__checkout-button, [data-kaching-checkout]');
    if (!checkoutBtn || checkoutBtn.dataset.purestreamCheckoutReady === 'true') return;

    if (checkoutBtn.dataset.purestreamCheckoutSyncing === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    checkoutBtn.dataset.purestreamCheckoutSyncing = 'true';
    markCheckoutStarted();

    dedupeGiftsBeforeCheckout().finally(function () {
      delete checkoutBtn.dataset.purestreamCheckoutSyncing;
      updateCartHeadingCount();
      checkoutBtn.dataset.purestreamCheckoutReady = 'true';
      checkoutBtn.click();
      delete checkoutBtn.dataset.purestreamCheckoutReady;
    });
  }, true);

  window.addEventListener('popstate', handleCheckoutReturn);
  window.addEventListener('pageshow', handleCheckoutReturn);
  handleCheckoutReturn();
})();